import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import api from "../../api";

const PromoQueue = () => {
  const [open, setOpen] = useState("1");
  const [promoQueue, setPromoQueue] = useState([]);
  const [editingPromo, setEditingPromo] = useState({});
  const [promoData, setPromoData] = useState({
    pq_name: "",
    pq_coins: "",
    pq_money: "",
    pq_starttime: "",
    pq_end: "",
    pq_gender: "M",
    pq_title: "",
  });

  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupColor, setPopupColor] = useState("red");

  useEffect(() => {
    fetchPromoQueue();
  }, []);

  const fetchPromoQueue = async () => {
    try {
      const response = await api.get(`/v1/admin/promo_queue`, {
        withCredentials: true,
      });
      setPromoQueue(response.data);
    } catch (error) {
      console.error("Error fetching promo queue:", error);
    }
  };

  const convertToEpoch = (datetimeStr) =>
    Math.floor(new Date(datetimeStr).getTime() / 1000);
  const convertFromEpoch = (epoch) =>
    new Date(epoch * 1000).toISOString().slice(0, 16);

  const showPopupMessage = (message, color = "red") => {
    setPopupMessage(message);
    setPopupColor(color);
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 3000);
  };

  const handleInputChange = (e) => {
    setPromoData({ ...promoData, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!promoData.pq_name || !promoData.pq_starttime || !promoData.pq_end) {
      showPopupMessage("Please fill out all required fields.", "red");
      return;
    }

    const updatedPromoData = {
      ...promoData,
      pq_starttime: convertToEpoch(promoData.pq_starttime),
      pq_end: convertToEpoch(promoData.pq_end),
    };

    try {
      const response = await api.post(
        `v1/admin/promo_queue`,
        updatedPromoData,
        { withCredentials: true },
      );
      showPopupMessage(response.data.message || "Promo queued!", "#1d222e");
      fetchPromoQueue();
      setPromoData({
        pq_name: "",
        pq_coins: "",
        pq_money: "",
        pq_starttime: "",
        pq_end: "",
        pq_gender: "m",
        pq_title: "",
      });
    } catch (error) {
      console.error("Error posting promo:", error);
      showPopupMessage(
        error.response?.detail || "Failed to queue promo.",
        "red",
      );
    }
  };

  const handleDeletePromo = async (pq_id) => {
    if (!window.confirm("Are you sure you want to delete this promo?")) return;
    try {
      await api.delete(`v1/admin/promo_queue/${pq_id}`, {
        withCredentials: true,
      });
      showPopupMessage("Promo removed from queue successfully!", "#1d222e");
      fetchPromoQueue();
    } catch (error) {
      console.error("Error deleting promo:", error);
      showPopupMessage(
        error.response.data?.detail || "Failed to delete promo.",
        "red",
      );
    }
  };

  const handleEditChange = (e, promoId) => {
    setEditingPromo({
      ...editingPromo,
      [promoId]: { ...editingPromo[promoId], [e.target.name]: e.target.value },
    });
  };

  const handleUpdatePromo = async (promo) => {
    const edited = editingPromo[promo.pq_id] || {};

    const updatedData = {
      pq_id: promo.pq_id,
      pq_name: promo.pq_name,
      pq_coins: edited.pq_coins ?? promo.pq_coins,
      pq_money: edited.pq_money ?? promo.pq_money,
      pq_starttime: edited.pq_starttime
        ? convertToEpoch(edited.pq_starttime)
        : promo.pq_starttime,
      pq_end: edited.pq_end ? convertToEpoch(edited.pq_end) : promo.pq_end,
      pq_gender: edited.pq_gender ?? promo.pq_gender,
      pq_title: promo.pq_title,
    };

    try {
      await api.put(`v1/admin/promo_queue`, updatedData, {
        withCredentials: true,
      });
      showPopupMessage("Promo updated successfully!", "#1d222e");
      fetchPromoQueue();
    } catch (error) {
      console.error("Error updating promo:", error);
      showPopupMessage(
        error.response.data?.detail || "Failed to update promo.",
        "red",
      );
    }
  };

  return (
    <div>
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: "50px",
            left: "50%",
            transform: "translateX(-50%)",
            padding: "15px",
            background: popupColor,
            color: "white",
            zIndex: 9999,
            border: "2px solid white",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            textAlign: "center",
          }}
        >
          {popupMessage}
        </div>
      )}

      <Accordion open={open} toggle={(id) => setOpen(open === id ? "" : id)}>
        {/* Upload Form Section */}
        <AccordionItem>
          <AccordionHeader targetId="1">Upload & Queue Promo</AccordionHeader>
          <AccordionBody accordionId="1">
            <Form onSubmit={handleFormSubmit}>
              <Row className="mb-3">
                <Label className="col-md-2 col-form-label">Pokémon Name</Label>
                <Col md="10">
                  <Input
                    type="text"
                    name="pq_name"
                    placeholder="Enter Pokémon name"
                    value={promoData.pq_name}
                    onChange={handleInputChange}
                    required
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-2 col-form-label">Promo Title</Label>
                <Col md="10">
                  <Input
                    type="text"
                    name="pq_title"
                    placeholder="Enter promo title"
                    value={promoData.pq_title}
                    onChange={handleInputChange}
                    required
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-2 col-form-label">Coins Cost</Label>
                <Col md="10">
                  <Input
                    type="number"
                    name="pq_coins"
                    placeholder="Enter coin cost"
                    value={promoData.pq_coins}
                    onChange={handleInputChange}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-2 col-form-label">Money Cost</Label>
                <Col md="10">
                  <Input
                    type="number"
                    name="pq_money"
                    placeholder="Enter money cost"
                    value={promoData.pq_money}
                    onChange={handleInputChange}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-2 col-form-label">
                  First 3 Promos
                </Label>
                <Col md="10">
                  <Input
                    type="select"
                    name="pq_gender"
                    value={promoData.pq_gender}
                    onChange={handleInputChange}
                  >
                    <option value="G">Ungendered</option>
                    <option value="N">Gendered</option>
                  </Input>
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-2 col-form-label">
                  Start Date & Time
                </Label>
                <Col md="10">
                  <Input
                    type="datetime-local"
                    name="pq_starttime"
                    value={promoData.pq_starttime}
                    onChange={handleInputChange}
                    required
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-2 col-form-label">
                  End Date & Time
                </Label>
                <Col md="10">
                  <Input
                    type="datetime-local"
                    name="pq_end"
                    value={promoData.pq_end}
                    onChange={handleInputChange}
                    required
                  />
                </Col>
              </Row>
              <Row>
                <Col md={{ size: 10, offset: 2 }}>
                  <Button color="success" type="submit">
                    Queue Promo
                  </Button>
                </Col>
              </Row>
            </Form>
          </AccordionBody>
        </AccordionItem>

        {/* Promo Queue List */}
        <AccordionItem>
          <AccordionHeader targetId="2">
            View & Edit Promo Queue
          </AccordionHeader>
          <AccordionBody accordionId="2">
            <Row>
              {promoQueue.map((promo) => (
                <Col md="6" lg="4" key={promo.pq_id} className="mb-3">
                  <div
                    className="p-3 shadow-sm"
                    style={{
                      border: "2px solid #ddd",
                      borderRadius: "10px",
                      backgroundColor: "#2d3448",
                    }}
                  >
                    <div className="text-center">
                      <img
                        src={`/sprites/${promo.pq_name}.png`}
                        alt={promo.pq_name}
                        style={{
                          width: "80px",
                          borderRadius: "8px",
                          padding: "5px",
                          backgroundColor: "#2d3448",
                        }}
                      />
                      <div
                        style={{
                          marginTop: "8px",
                          color: "#fff",
                          fontWeight: "bold",
                        }}
                      >
                        {promo.pq_name}
                      </div>
                    </div>
                    <Form className="mt-2">
                      <Label>Coins</Label>
                      <Input
                        type="number"
                        name="pq_coins"
                        value={
                          editingPromo[promo.pq_id]?.pq_coins ?? promo.pq_coins
                        }
                        onChange={(e) => handleEditChange(e, promo.pq_id)}
                      />
                      <Label className="mt-2">Money</Label>
                      <Input
                        type="number"
                        name="pq_money"
                        value={
                          editingPromo[promo.pq_id]?.pq_money ?? promo.pq_money
                        }
                        onChange={(e) => handleEditChange(e, promo.pq_id)}
                      />
                      <Label className="mt-2">First 3 Promos</Label>
                      <Input
                        type="select"
                        name="pq_gender"
                        value={
                          editingPromo[promo.pq_id]?.pq_gender ??
                          promo.pq_gender
                        }
                        onChange={(e) => handleEditChange(e, promo.pq_id)}
                      >
                        <option value="G">Ungendered</option>
                        <option value="M">Gendered</option>
                      </Input>
                      <Label className="mt-2">Start Time</Label>
                      <Input
                        type="datetime-local"
                        name="pq_starttime"
                        value={
                          editingPromo[promo.pq_id]?.pq_starttime ??
                          convertFromEpoch(promo.pq_starttime)
                        }
                        onChange={(e) => handleEditChange(e, promo.pq_id)}
                      />
                      <Label className="mt-2">End Time</Label>
                      <Input
                        type="datetime-local"
                        name="pq_end"
                        value={
                          editingPromo[promo.pq_id]?.pq_end ??
                          convertFromEpoch(promo.pq_end)
                        }
                        onChange={(e) => handleEditChange(e, promo.pq_id)}
                      />
                      <Row className="mt-3">
                        <Col xs="6">
                          <Button
                            color="success"
                            className="w-100"
                            onClick={() => handleUpdatePromo(promo)}
                          >
                            Update
                          </Button>
                        </Col>
                        <Col xs="6">
                          <Button
                            color="danger"
                            className="w-100"
                            onClick={() => handleDeletePromo(promo.pq_id)}
                          >
                            Delete
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </Col>
              ))}
            </Row>
          </AccordionBody>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default PromoQueue;
